import React, { useState } from 'react';
import QuickActions from '../pages/crm/QuickActions';

// Call / Text / Email for a lead task on the main Tasks page (the same QuickActions the dashboard Lead Tasks use,
// so Do Not Call, opt-outs and archived contacts are respected). Finds the contact from the task's lead link,
// or from the buyer/seller pipeline record it points to.
export const contactForTask = (task, contacts = [], sellers = [], buyers = []) => {
  if (!task) return null;
  const rec = task.sellerInterestId ? sellers.find((r) => r.id === task.sellerInterestId)
    : task.buyerInterestId ? buyers.find((r) => r.id === task.buyerInterestId) : null;
  const cid = task.crmContactId || (rec && rec.contactId);
  return cid ? contacts.find((c) => c.id === cid) || null : null;
};

export default function LeadTaskQuickActions({ task, contact, uid, isAdmin, senderName, onCleared }) {
  const [open, setOpen] = useState(false);
  if (!contact || task?.source === 'transaction') return null;
  return (
    <div style={{ marginTop: 8 }}>
      <button type="button" onClick={() => setOpen(!open)}
        style={{ padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF', cursor: 'pointer' }}>
        {open ? 'Hide actions' : 'Call / Text / Email'}
      </button>
      {open && <div style={{ marginTop: 8 }}><QuickActions contact={contact} uid={uid} isAdmin={isAdmin} senderName={senderName} compact task={task} onTaskCleared={() => { setOpen(false); onCleared && onCleared(); }} /></div>}
    </div>
  );
}
